//------------------------------------------------
//
//	ReU: 固定SNSボタン（画面右端の縦積み）
//	ファーストビューでは出さず、1画面分スクロールしたら出す。
//	× で畳むと ‹ だけが残り、押せば戻る。畳んだ記録はタブを閉じるまで。
//
//	🔑 出す/出さないの線は毎回その場で測る（画面の高さは端末や回転で変わるため）。
//
//------------------------------------------------
const STICKY_SOCIAL_KEY = 'stickySocialClosed';

class StickySocial extends HTMLElement {
    connectedCallback() {
        this.button = this.querySelector('button');
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);

        if (this.button) {
            if (StickySocial.wasClosed()) this.classList.add('isClosed');
            this.syncButton();
            this.button.addEventListener('click', () => this.toggle());
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            this.classList.toggle('isShown', window.scrollY >= window.innerHeight);
            this.ticking = false;
        });
    }

    toggle() {
        const closed = this.classList.toggle('isClosed');
        StickySocial.remember(closed);
        this.syncButton();
    }

    syncButton() {
        this.button.setAttribute('aria-expanded', String(!this.classList.contains('isClosed')));
    }

    static wasClosed() {
        try {
            return sessionStorage.getItem(STICKY_SOCIAL_KEY) === '1';
        } catch (error) {
            return false;
        }
    }

    static remember(closed) {
        try {
            if (closed) {
                sessionStorage.setItem(STICKY_SOCIAL_KEY, '1');
            } else {
                sessionStorage.removeItem(STICKY_SOCIAL_KEY);
            }
        } catch (error) {
            /* プライベートモード等では記憶しない */
        }
    }
}

customElements.define('sticky-social', StickySocial);
